import React from 'react';

import Table from '../../../../../components/table/Table';
import {
  ACCOUNT_USER_DEVICE_LIST_TABLE_EMPTY_TEXT,
  ACCOUNT_USER_DEVICE_TIMELINE_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/accountUserConstants';
import { columns, DeviceListTableColumnUtilType } from './columns';
import { useAccountUserDetailVisitorLogListViewModel } from './hooks/useAccountUserDetailVisitorLogList';
import { PaginationType } from './types/userDetailVisitorLog';
import { useAccountUserDetailQuery } from '../common/hooks';
import { AccountUserDetailType } from '../common/types/accountUserDetail';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';

interface IAccountUserDetailDeviceListProps {
  userId: number;
  isActive: boolean;
}
const AccountUserDetailDeviceList = (props: IAccountUserDetailDeviceListProps): JSX.Element => {
  const { userId, isActive } = props;
  const { visitorTimeLineList, visitorLogListPagination, paginateVisitorLogList } =
    useAccountUserDetailVisitorLogListViewModel(userId, isActive);
  const { data: visitorList } = useAccountUserDetailQuery<AccountUserDetailType['visitorList']>({
    userId,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_REQUEST_SUCCESS),
      onError: (error) => toastMsg.error(error.message),
      select: (result) => result.data.visitorList,
    },
  });

  /* 디바이스 타임라인 리스트 */
  return (
    <div className="account-user-detail-content">
      {/* 디바이스 리스트 */}
      <div className="account-user-detail-section">
        <div className="title">디바이스 리스트 (최신순)</div>

        <div className="account-user-detail-section-content">
          <Table
            className="account-user-detail-section-list"
            data={visitorList}
            isStriped={true}
            emptyText={ACCOUNT_USER_DEVICE_LIST_TABLE_EMPTY_TEXT}
            maxHeight={400}
            columns={(utils: Pick<DeviceListTableColumnUtilType, 'isVisitorLogTable' | 'list'>) =>
              columns({
                isVisitorTable: true,
                ...utils,
              })
            }
          />
        </div>
      </div>
      <div className="account-user-detail-section">
        <div className="title">디바이스 타임라인 리스트 (최신순)</div>

        <div className="account-user-detail-section-content">
          <Table
            className="account-user-detail-section-list"
            data={visitorTimeLineList}
            isStriped={true}
            showPagination
            emptyText={ACCOUNT_USER_DEVICE_TIMELINE_LIST_TABLE_EMPTY_TEXT}
            maxHeight={400}
            pagination={visitorLogListPagination}
            getList={({ pagination }: { pagination: PaginationType }) => paginateVisitorLogList(pagination)}
            columns={(utils: Pick<DeviceListTableColumnUtilType, 'isVisitorTable' | 'list'>) =>
              columns({
                isVisitorLogTable: true,
                ...utils,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AccountUserDetailDeviceList;
